module.exports = __webpack_public_path__ + "assets/1312ae73faa1b84cc2af1d75206a1374.mp4";